import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';

type Props = {
  title: string;
  message: string;
};

export const AssociatedDealerPriceWarning = ({ title, message }: Props) => {
  return (
    <CatInlineNotification heading={title} variant="warning">
      <>
        <CatIconWarningTriangle slot="before" />
        {message}
      </>
    </CatInlineNotification>
  );
};
